<template> 
  <div>
    <div class="d-flex flex-stack flex-wrap mb-2">
        <div class="page-title d-flex flex-column me-3 mt-3"> 
            <h1 class="d-flex fw-bolder my-1 fs-3 text-gray-800">{{ $t('bank_data_import') }}</h1>  
            <ul class="breadcrumb breadcrumb-dot fw-bold text-gray-600 fs-7 my-1"> 
                <li class="breadcrumb-item text-gray-600">
                    <a href="#" class="text-gray-600 text-hover-primary">
                        <router-link :to="{ name: 'Home' }">{{ $t('home') }}</router-link>
                    </a>
                </li> 
                <li class="breadcrumb-item text-gray-600"><router-link :to="{ name: 'Settings' }">{{ $t('settings') }}</router-link></li>     
                <li class="breadcrumb-item text-gray-600">{{ $t('bank_data_import') }}</li> 
            </ul> 
        </div>
    </div>
    <div class="card shadow-sm">
        <div class="card-header">
            <h3 class="card-title">{{ $t('bank_data_import') }}</h3>
            <div class="d-flex flex-stack flex-wrap mb-2">                
                <div class="d-flex justify-content-end" data-kt-docs-table-toolbar="base">
                    <button ref="openTransactionModal" v-if="this.$isCredentialActive(77,'I')" type="button" class="btn btn-sm btn-primary fw-bold required me-3" data-bs-toggle="modal" :disabled="isImporting"
                        data-bs-target="#kt_modal_add_item" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end" @click="this.getLists()">
                        <span class="svg-icon svg-icon-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="11.364" y="20.364" width="16" height="2" rx="1"
                                    transform="rotate(-90 11.364 20.364)" fill="currentColor"></rect>
                                <rect x="4.36396" y="11.364" width="16" height="2" rx="1"
                                    fill="currentColor">
                                </rect>
                            </svg>
                        </span>
                        {{ $t('add_bank_data_import') }}
                    </button>
                    
                    <div class="dropdown" v-if="this.$isCredentialActive(77,'D')">
                        <button class="btn btn-sm btn-light-info fw-bold border border-info dropdown-toggle me-3" data-bs-toggle="dropdown" aria-expanded="true" id="cashActions" type="button" :disabled="isImporting">
                            <span class="svg-icon svg-icon-muted">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path opacity="0.3" d="M22.1 11.5V12.6C22.1 13.2 21.7 13.6 21.2 13.7L19.9 13.9C19.7 14.7 19.4 15.5 18.9 16.2L19.7 17.2999C20 17.6999 20 18.3999 19.6 18.7999L18.8 19.6C18.4 20 17.8 20 17.3 19.7L16.2 18.9C15.5 19.3 14.7 19.7 13.9 19.9L13.7 21.2C13.6 21.7 13.1 22.1 12.6 22.1H11.5C10.9 22.1 10.5 21.7 10.4 21.2L10.2 19.9C9.4 19.7 8.6 19.4 7.9 18.9L6.8 19.7C6.4 20 5.7 20 5.3 19.6L4.5 18.7999C4.1 18.3999 4.1 17.7999 4.4 17.2999L5.2 16.2C4.8 15.5 4.4 14.7 4.2 13.9L2.9 13.7C2.4 13.6 2 13.1 2 12.6V11.5C2 10.9 2.4 10.5 2.9 10.4L4.2 10.2C4.4 9.39995 4.7 8.60002 5.2 7.90002L4.4 6.79993C4.1 6.39993 4.1 5.69993 4.5 5.29993L5.3 4.5C5.7 4.1 6.3 4.10002 6.8 4.40002L7.9 5.19995C8.6 4.79995 9.4 4.39995 10.2 4.19995L10.4 2.90002C10.5 2.40002 11 2 11.5 2H12.6C13.2 2 13.6 2.40002 13.7 2.90002L13.9 4.19995C14.7 4.39995 15.5 4.69995 16.2 5.19995L17.3 4.40002C17.7 4.10002 18.4 4.1 18.8 4.5L19.6 5.29993C20 5.69993 20 6.29993 19.7 6.79993L18.9 7.90002C19.3 8.60002 19.7 9.39995 19.9 10.2L21.2 10.4C21.7 10.5 22.1 11 22.1 11.5ZM12.1 8.59998C10.2 8.59998 8.6 10.2 8.6 12.1C8.6 14 10.2 15.6 12.1 15.6C14 15.6 15.6 14 15.6 12.1C15.6 10.2 14 8.59998 12.1 8.59998Z" fill="currentColor"/>
                                <path d="M17.1 12.1C17.1 14.9 14.9 17.1 12.1 17.1C9.30001 17.1 7.10001 14.9 7.10001 12.1C7.10001 9.29998 9.30001 7.09998 12.1 7.09998C14.9 7.09998 17.1 9.29998 17.1 12.1ZM12.1 10.1C11 10.1 10.1 11 10.1 12.1C10.1 13.2 11 14.1 12.1 14.1C13.2 14.1 14.1 13.2 14.1 12.1C14.1 11 13.2 10.1 12.1 10.1Z" fill="currentColor"/>
                                </svg>
                            </span>
                            {{$t('actions')}}
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="cashActions">
                            <li>
                                <div class="menu-content fs-6 text-gray-900 fw-bold px-2 py-3 w-200px" :class="{'text-gray-800': deleteMode}">
                                    <div class="form-check form-switch">
                                        <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="deleteMode" @change="toggleDeleteMode()">
                                        <label class="form-check-label fw-bold" for="flexSwitchCheckDefault">{{$t('multi_actions_mode')}}</label>
                                    </div>
                                    <small v-if="deleteMode" class="text-muted float-end fw-light fs-8">{{$t('select_data_from_the')}}...</small>
                                </div>
                            </li> 
                            <div class="separator my-3"></div>
                            <!-- <li>
                                <button class="dropdown-item fw-bold fs-6 p-2" :class="{'text-gray-800': deleteMode && this.selectedRowDeleteKeys.length == 0,'text-primary': this.selectedRowDeleteKeys.length > 0}" @click="updateForm.transaction_in_out = 0"
                                    data-bs-toggle="modal" data-bs-target="#kt_update_data_modal"  :disabled="this.selectedRowDeleteKeys.length == 0">
                                    {{ $t('update_selected') }} <span v-if="tempDataList != null">({{ this.selectedRowDeleteKeys.length }})</span>
                                </button>
                            </li>  -->
                            <li>
                                <button class="dropdown-item fw-bold fs-6 p-2" :class="{'text-gray-800': deleteMode && this.selectedRowDeleteKeys.length == 0, 'text-danger': this.selectedRowDeleteKeys.length > 0}" @click="this.onDeleteSelectedTransactions()" :disabled="this.selectedRowDeleteKeys.length == 0">
                                    {{ $t('delete_selected') }} <span v-if="tempDataList != null">({{ this.selectedRowDeleteKeys.length }})</span>
                                </button>
                            </li> 
                            <div class="separator"></div>
                            <li>
                                <button class="dropdown-item fw-bold fs-6 p-2" @click="onDeleteAllTempTransactions()" :disabled="isImporting">
                                    {{ $t('empty_table') }}
                                </button>
                            </li>
                        </ul>
                    </div>
                </div> 
            </div>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-lg-6">
                    <div class="row">
                        <div class="col-lg-4">
                            <label class="fs-6 fw-bold form-label">
                                <span>{{ $t('status') }}</span> 
                            </label>   
                            <Select2 v-model="filterForm.record_status" :disabled="isImporting" :options="filterStatusList" :settings="{ width: '100%' }"/>  
                        </div>
                        <div class="col-lg-4">
                            <label class="fs-6 fw-bold form-label">
                                <span>{{ $t('bank_account') }}</span> 
                            </label>
                            <Select2 v-model="filterForm.bank_account_id" :options="bankAccountList" name="bank_account_id" :settings="{width: '100%'}" />
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="d-flex justify-content-end align-self-center mt-10"> 
                        <Popper hover placement="top" v-if="this.$isCredentialActive(77,'R')">
                            <button type="button" class="btn btn-light border border-gray-300 btn-icon me-3" @click="this.setCriteriasToDefault()">
                                <i class="bi bi-eraser-fill fs-4"> </i>
                            </button>
                            <template #content>
                                <span class="text-gray-800"> {{ $t('reset_all_criterias') }} </span>
                            </template>
                        </Popper>
                        <button type="button" v-if="this.$isCredentialActive(77,'R')" class="btn btn-light border border-gray-400 me-3" @click="this.getData()" data-kt-indicator="on" :disabled="isImporting"> 
                            <span class="svg-icon svg-icon-muted svg-icon-2"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M14.5 20.7259C14.6 21.2259 14.2 21.826 13.7 21.926C13.2 22.026 12.6 22.0259 12.1 22.0259C9.5 22.0259 6.9 21.0259 5 19.1259C1.4 15.5259 1.09998 9.72592 4.29998 5.82592L5.70001 7.22595C3.30001 10.3259 3.59999 14.8259 6.39999 17.7259C8.19999 19.5259 10.8 20.426 13.4 19.926C13.9 19.826 14.4 20.2259 14.5 20.7259ZM18.4 16.8259L19.8 18.2259C22.9 14.3259 22.7 8.52593 19 4.92593C16.7 2.62593 13.5 1.62594 10.3 2.12594C9.79998 2.22594 9.4 2.72595 9.5 3.22595C9.6 3.72595 10.1 4.12594 10.6 4.02594C13.1 3.62594 15.7 4.42595 17.6 6.22595C20.5 9.22595 20.7 13.7259 18.4 16.8259Z" fill="currentColor"/>
                            <path opacity="0.3" d="M2 3.62592H7C7.6 3.62592 8 4.02592 8 4.62592V9.62589L2 3.62592ZM16 14.4259V19.4259C16 20.0259 16.4 20.4259 17 20.4259H22L16 14.4259Z" fill="currentColor"/>
                            </svg>
                            </span>
                            <span v-if="!this.isTempLoading"> {{ $t('list_transactions') }} </span>
                            <span class="indicator-progress" v-if="this.isTempLoading">
                                {{ $t('getting_data') }} <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span> 
                        </button>
                        <button type="button" class="btn btn-sm btn-light d-none" ref="LoadingModal" data-bs-toggle="modal" data-bs-target="#kt_modal_loading" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                        </button>
                        <button v-if="this.$isCredentialActive(77,'I')" type="button" class="btn btn-sm btn-success" @click="onSaveReadyTransactions()" :disabled="this.selectedRowKeys.length == 0 || isImporting"> 
                            <span class="svg-icon svg-icon-muted svg-icon-2">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
                                    <path opacity="0.5" d="M12.4343 12.4343L10.75 10.75C10.3358 10.3358 9.66421 10.3358 9.25 10.75C8.83579 11.1642 8.83579 11.8358 9.25 12.25L12.2929 15.2929C12.6834 15.6834 13.3166 15.6834 13.7071 15.2929L19.25 9.75C19.6642 9.33579 19.6642 8.66421 19.25 8.25C18.8358 7.83579 18.1642 7.83579 17.75 8.25L13.5657 12.4343C13.2533 12.7467 12.7467 12.7467 12.4343 12.4343Z" fill="currentColor"/>
                                    <path d="M8.43431 12.4343L6.75 10.75C6.33579 10.3358 5.66421 10.3358 5.25 10.75C4.83579 11.1642 4.83579 11.8358 5.25 12.25L8.29289 15.2929C8.68342 15.6834 9.31658 15.6834 9.70711 15.2929L15.25 9.75C15.6642 9.33579 15.6642 8.66421 15.25 8.25C14.8358 7.83579 14.1642 7.83579 13.75 8.25L9.56569 12.4343C9.25327 12.7467 8.74673 12.7467 8.43431 12.4343Z" fill="currentColor"/>
                                </svg>
                            </span>
                            {{ $t('save_ready_transactions') }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="separator my-5 border-gray-300"></div>
            <div class="row">
                <div class="card card-xxl-stretch py-3">
                    <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div class="table-responsive-lg">
                            <button class="btn btn-sm btn-light" :disabled="buttonDisabled" @click="clearSelection">
                                {{ $t('deselect_all') }} ({{ buttonCount }})
                            </button>
                            
                            <DxDataGrid id="gridContainer" :key="$i18n.locale" 
                                ref="dxTempList"
                                :show-borders="true" 
                                key-expr="id" 
                                :data-source="tempDataList" 
                                :allow-column-reordering="true"  
                                :allow-column-resizing="true" 
                                :column-auto-width="true" 
                                :row-alternatin-enabled="true"
                                :hover-state-enabled="true" 
                                :show-row-lines="true"
                                :cache_enabled="true"
                                @exporting="this.$onExporting($event, getFileName)"
                                :v-model:selected-row-keys="selectedRowKeys"
                                @selection-changed="onSelectionChanged">

                                <DxSelection mode="multiple" :select-all-mode="allMode" show-check-boxes-mode="always" v-if="!deleteMode"/>
                                <DxSelection mode="multiple" show-check-boxes-mode="always" v-if="deleteMode"/>
                                <DxFilterRow :visible="true"/>
                                <DxHeaderFilter :visible="true"/>
                                <DxGroupPanel :visible="true"/>      
                                <DxExport :enabled="true" :formats="['xlsx', 'pdf']" :allow-export-selected-data="false"/>
                                <DxPaging :page-size="50"/>
                                <DxPager :visible="false" :allowed-page-sizes="pageSizes(tempDataList, 50)" :show-page-size-selector="showPageSizeSelector(tempDataList, 50)" :show-info="true" :show-navigation-buttons="true"/> 
                                <DxSearchPanel :visible="true"/>

                                <DxScrolling
                                    mode="virtual"
                                    row-rendering-mode="virtual"
                                />  
                                <DxColumn caption="#" cell-template="save-cell-template" css-class="align-middle" :allow-filtering="false"/>
                                <DxColumn data-field="record_status" caption="Status" cell-template="record-cell-template" css-class="align-middle"/> 
                                <DxColumn data-field="transaction_date" :caption="$t('transaction_date')" data-type="date" format="dd.MM.yyyy" css-class="align-middle" />
                                <DxColumn data-field="transaction_type" :caption="$t('transaction_type')" cell-template="transaction_type-cell-template" css-class="align-middle" />
                                <DxColumn data-field="transaction_in_out" :caption="$t('inout')" cell-template="transaction_in_out-cell-template" css-class="align-middle" />
                                <DxColumn data-field="transaction_description" :caption="$t('description')" cell-template="transaction_description-cell-template" css-class="align-middle" />
                                <DxColumn data-field="target_account_name" :caption="$t('account_to_be_saved')" cell-template="target_account_name-cell-template" css-class="align-middle"/>
                                <DxColumn data-field="transaction_currency" :caption="$t('currency')" css-class="align-middle" />
                                <DxColumn data-field="transaction_rate" alignment="right" :sorting-method="this.$numericSort" :caption="$t('rate')" css-class="align-middle" />
                                <DxColumn data-field="transaction_amount" alignment="right" :sorting-method="this.$numericSort" :caption="$t('amount')" css-class="align-middle" />
                                <DxColumn data-field="balance" :caption="$t('balance')" :sorting-method="this.$numericSort" alignment="right" css-class="align-middle"/>
                                <DxColumn data-field="transaction_amount_local" alignment="right" :sorting-method="this.$numericSort" :caption="$t('local_amount')" css-class="align-middle" />
                                <DxColumn data-field="local_bank_account_name" :caption="$t('local_bank_name')" css-class="align-middle" />
                                <DxColumn data-field="target_bank_account_short_code" :caption="$t('target_bank_short_code')" css-class="align-middle" />
                                <DxColumn data-field="target_bank_account_number" :caption="$t('target_bank_account_number')" css-class="align-middle" />
                                <DxColumn data-field="target_bank_account_iban" :caption="$t('target_bank_iban')" css-class="align-middle" />
                                <DxColumn data-field="target_bank_account_code" :caption="$t('target_bank_code')" css-class="align-middle" />
                                <DxColumn data-field="target_bank_account_name" :caption="$t('target_bank_name')" css-class="align-middle" />
                                <template #headerLocalTemplate="{ data: data }"> <div v-html="setColumnTemplateForLocal(data)"></div> </template>

                                <template #record-cell-template="{ data }">
                                    <span>
                                        <span v-if="data.data.id !== null && data.data.id !== ''">
                                            <span class="align-middle text-center cursor-pointer" :id="'popover_'+ data.rowIndex">
                                                <div v-if="data.data.is_recorded == 0">
                                                    <div class="text-danger" v-if="!isReadyToSave(data.data)">
                                                        Not Ready
                                                    </div>
                                                    <div class="text-success"
                                                        v-if="isReadyToSave(data.data)">
                                                        Ready
                                                    </div>
                                                </div>
                                                <div v-if="data.data.is_recorded !== 0">
                                                    <div class="text-success">
                                                        <i class="fa fa-check-circle text-success me-1" style="font-size: 12px;"></i> 
                                                        <span> Saved</span>
                                                    </div>
                                                    <small v-if="data.data.recorded_docket_number !== '' && data.data.recorded_docket_number !== null" class="fw-semibold">
                                                        ({{data.data.recorded_docket_number}})
                                                    </small>
                                                </div>
                                            </span>
                                            
                                            <DxPopover v-if="data.data.is_recorded == 0"
                                                :width="300"
                                                :show-title="true"
                                                show-event="mouseenter"
                                                hide-event="mouseleave"
                                                :target="'#popover_'+ data.rowIndex"
                                                position="left"
                                                title="Status">
                                                <table class="table table-row-dashed mb-0"> 
                                                    <tr class="text-start" v-if="data.data.target_account_id == '' || (data.data.target_account_number == '' && data.data.target_account_name == '')">
                                                        <td class="pt-2 pb-2 fw-bolder"><i class="bi bi-asterisk text-danger"></i> 
                                                            <span>Customer Account Info is required. Transaction does not have any account info!</span>
                                                        </td>
                                                    </tr>
                                                    <tr class="text-start" v-if="data.data.in_out == 0">
                                                        <td class="pt-2 pb-2 fw-bolder"><i class="bi bi-asterisk text-danger"></i> 
                                                            <span>In/Out information must be defined!</span>
                                                        </td>
                                                    </tr>
                                                    <tr class="text-start" v-if="data.data.target_account_id !== ''">
                                                        <td class="pt-2 pb-2 fw-bolder"><i class="bi bi-check-all text-success"></i> 
                                                            <span>Customer Account is ready!</span>
                                                        </td>
                                                    </tr>
                                                    <tr class="text-start" v-if="isReadyToSave(data.data)">
                                                        <td class="pt-2 pb-2 fw-bolder"> 
                                                            <i class="bi bi-check-all text-success"></i> 
                                                            <span>Transaction is ready to save!</span>
                                                        </td>
                                                    </tr>
                                                </table>
                                            </DxPopover>
                                            
                                            <i class="bi bi-info-circle text-danger float-end cursor-pointer text-end" :id="'popover_error_'+ data.rowIndex" v-if="data.data.is_recorded == 0 && data.data.last_error !== null && data.data.last_error !== '' && data.data.last_error !== undefined"></i>
                                            <DxPopover v-if="data.data.is_recorded == 0 && data.data.last_error !== null && data.data.last_error !== '' && data.data.last_error !== undefined"
                                                :width="300"
                                                :show-title="true"
                                                :target="'#popover_error_'+ data.rowIndex"
                                                position="right"                                            
                                                show-event="mouseenter"
                                                hide-event="mouseleave"
                                                title="Last Error">
                                                <div class="text-danger">
                                                    <span>{{data.data.last_error}}</span>
                                                </div>
                                            </DxPopover>
                                        </span>
                                    </span>
                                </template>  
                                <template #is_policy_card_exists-cell-template="{  data }">
                                    <span class="align-middle text-start">
                                        <div>
                                            <span v-if="data.data.is_policy_card_exists == 0"> 
                                                <span>Not Saved </span>
                                            </span>
                                        </div> 
                                        <div>
                                            <span v-if="data.data.is_policy_card_exists == 1"> 
                                                <i class="fa fa-check-circle text-success me-1" style="font-size: 12px;"></i> 
                                                <span> Saved</span>
                                            </span>
                                        </div> 
                                    </span>
                                </template>
                                <template #transaction_description-cell-template="{  data }">
                                    <span class="align-middle text-start">
                                        <div v-if="data.data.transaction_description !== '' && data.data.transaction_description !== null && data.data.transaction_description !== undefined">
                                            <a href="#" target="_self" class="text-gray-800" 
                                                @click="openTransferParameterForm(data.data)"
                                                data-bs-toggle="modal" data-bs-target="#kt_transfer_parameter_modal" 
                                                data-bs-original-title="Transfer Parameter Modal">
                                                <span><i class="bi bi-search me-2"></i> </span>
                                            </a>
                                        </div>
                                        <div>
                                            <span class="me-2" v-if="data.data.is_parameter_defined == 1">
                                                <i class="fa fa-check-circle text-success" style="font-size: 12px;"></i>
                                            </span>
                                            <span>
                                                {{ data.data.transaction_description }} 
                                            </span> 
                                        </div> 
                                    </span>
                                </template>
                                <template #transaction_in_out-cell-template="{  data }">
                                    <span class="align-middle text-start">
                                        <div v-if="data.data.transaction_in_out !== '' && data.data.transaction_in_out !== null && data.data.transaction_in_out !== undefined">
                                            <a href="#" target="_self" class="text-gray-800" 
                                                @click="openTransferParameterForm(data.data)"
                                                data-bs-toggle="modal" data-bs-target="#kt_transfer_parameter_modal" 
                                                data-bs-original-title="Transfer Parameter Modal">
                                                <span><i class="bi bi-search me-2"></i> </span>
                                            </a>
                                        </div>
                                        <div>
                                            <span class="me-2" v-if="data.data.is_parameter_defined == 1">
                                                <i class="fa fa-check-circle text-success" style="font-size: 12px;"></i>
                                            </span>
                                            <span>
                                                {{ data.data.transaction_in_out }} 
                                            </span> 
                                        </div> 
                                    </span>
                                </template>
                                <template #transaction_type-cell-template="{  data }">
                                    <span class="align-middle text-start">
                                        <div v-if="data.data.transaction_type !== '' && data.data.transaction_type !== null && data.data.transaction_type !== undefined">
                                            <a href="#" target="_self" class="text-gray-800" 
                                                @click="openTransferParameterForm(data.data)"
                                                data-bs-toggle="modal" data-bs-target="#kt_transfer_parameter_modal" 
                                                data-bs-original-title="Transfer Parameter Modal">
                                                <span><i class="bi bi-search me-2"></i> </span>
                                            </a>
                                        </div>
                                        <div>
                                            <span class="me-2" v-if="data.data.is_parameter_defined == 1">
                                                <i class="fa fa-check-circle text-success" style="font-size: 12px;"></i>
                                            </span>
                                            <span>
                                                {{ data.data.transaction_type }} 
                                            </span> 
                                        </div> 
                                    </span>
                                </template>
                                <template #target_account_name-cell-template="{  data }">
                                    <span class="align-middle text-start">
                                        <div class="fw-bold">
                                            <a href="#" target="_self" class="text-gray-800" 
                                                data-bs-toggle="modal" data-bs-target="#kt_search_account_modal" 
                                                @click="openSearchModal(data.data.target_account_name, data.data.id)"
                                                data-bs-original-title="Account Search Modal">
                                                <span><i class="bi bi-search me-2"></i> </span>
                                                <span>{{ data.data.target_account_number }}</span>
                                            </a>
                                        </div>
                                        <div>
                                            <span class="me-2">
                                                <i class="fa fa-check-circle text-danger" v-if="data.data.target_account_id == ''" style="font-size: 12px;"></i>
                                                <i class="fa fa-check-circle text-success" v-if="data.data.target_account_id !== ''" style="font-size: 12px;"></i>
                                            </span>
                                            <span v-if="data.data.target_account_name !== null && data.data.target_account_name !== undefined && data.data.target_account_name !== ''"> {{ data.data.target_account_name }} </span> 
                                            <span class="text-danger" v-else> {{ $t('select_an_account') }} </span> 
                                        </div> 
                                    </span>
                                </template>
                                <template #save-cell-template="{  data }">
                                    <span class="align-middle text-start">                                        
                                        <button v-if="data.data.is_recorded !== 1 && isReadyToSave(data.data)" type="button" class="btn btn-light-success btn-sm px-2 py-1" @click="onSaveReadyTransactions(data.data.id)">
                                            <span class="svg-icon svg-icon-5">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path opacity="0.3" d="M10 18C9.7 18 9.5 17.9 9.3 17.7L2.3 10.7C1.9 10.3 1.9 9.7 2.3 9.3C2.7 8.9 3.29999 8.9 3.69999 9.3L10.7 16.3C11.1 16.7 11.1 17.3 10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                                    <path d="M10 18C9.7 18 9.5 17.9 9.3 17.7C8.9 17.3 8.9 16.7 9.3 16.3L20.3 5.3C20.7 4.9 21.3 4.9 21.7 5.3C22.1 5.7 22.1 6.30002 21.7 6.70002L10.7 17.7C10.5 17.9 10.3 18 10 18Z" fill="currentColor"/>
                                                </svg>
                                            </span>
                                            <small class="fs-7"> {{ $t('save') }}</small>
                                        </button>
                                    </span>
                                </template>
                                
                                <DxSummary>
                                    <DxTotalItem column="record_status" summary-type="count" :display-format="`${$t('record')}: {0}`" show-in-column="record_status"/>
                                </DxSummary>
                            </DxDataGrid>   
                        </div>
                    </div> 
                    <div class="d-flex flex-row-reverse mt-3">
                        <DxSelectBox
                            id="select-all-mode"
                            placeholder="Select All Mode"
                            :items="selectAllModes"
                            v-model="allMode"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="modal fade" id="kt_modal_loading" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-lg top-25">
            <div class="modal-content">
                <div class="modal-header bg-primary min-h-20px py-2">
                    <h2 class="modal-title fw-bolder col-md-10 text-white">
                        Saving...         
                    </h2>
                </div>
                <div class="modal-body scroll-y bg-light-primary">
                    <div class="fs-5 text-center">
                        {{ $t('transactions_saving_in_progress') }}.
                    </div>
                    <div class="progress mt-5 h-20px">
                        <div class="progress-bar progress-bar-striped progress-bar-animated fs-7" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%;">
                            {{ $t('saving') }}... {{ $t('please_wait') }}!
                        </div>
                    </div>
                    <button class="btn btn-icon btn-sm btn-active-icon-primary d-none" data-bs-dismiss="modal" aria-label="Close" ref="closeLoadingModal"></button>
                </div> 
                <div class="modal-footer row py-3 mx-0">
                    <div class="d-grid gap-2">
                        <button type="button" class="btn btn-light-danger btn-sm fw-bold" @click="onCancelDataImport()">
                            {{ $t('cancel_transaction') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- IMPORT MODAL -->
    <div class="modal fade" id="kt_modal_add_item" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog">
            <div class="modal-content"  >
                <div class="modal-header bg-primary">
                    <h2 class="modal-title fw-bolder col-md-10 text-white">
                        <span v-if="this.modalType == 'addItem'"> {{ $t('new_bank_data_import') }} </span>
                        <span v-if="this.modalType == 'editItem'"> {{ $t('edit') }} </span>             
                    </h2>                        
                    <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal" aria-label="Close" ref="closeImportModal">
                        <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body scroll-y">
                    <div class="preloader vh-100" v-if="this.isDataTransferring">
                        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                            <span class="visually-hidden">{{ $t('loading') }}...</span>
                        </div>
                    </div>
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-12">
                                    <label class="fs-6 fw-bold form-label mt-3">                                        
                                        <span>{{ $t('select_bank_account') }}</span> 
                                    </label>
                                    <Select2 v-model="form.bank_account_id" :options="bankAccountList" name="bank_account_id"
                                        :settings="{width: '100%', dropdownParent: '#kt_modal_add_item .modal-content'}" @select="onChangeAccount($event)" />
                                </div>
                                <div class="col-lg-12" v-if="this.selectedTemplate != null && this.selectedTemplate != '' && this.selectedTemplate != undefined">
                                    <span v-if="this.selectedTemplate.dll_template_id != null && this.selectedTemplate.dll_template_id != ''">
                                        <label class="fs-6 fw-bold form-label mt-3">
                                            {{ $t('dll_information') }}
                                        </label>
                                        <div class="alert alert-dismissible bg-success d-flex flex-column flex-sm-row w-100 p-5 mb-5" v-if="this.selectedTemplate != null && this.selectedTemplate != '' && this.selectedTemplate != undefined">
                                            <span class="svg-icon svg-icon-dark svg-icon-2hx">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
                                                <path d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z" fill="currentColor"/>
                                                </svg>
                                            </span>
                                            <div class="d-flex flex-column ps-4 pe-0 pe-sm-10">
                                                <h4 class="fw-semibold">{{ $t('a_working_dll_file') }}!</h4>
                                                <span><i class="fas fa-cogs text-gray-800"></i> <strong> {{ this.selectedTemplate.dll_template_name }} </strong> template will be used for this Data Import.</span>
                                            </div>
                                        </div> 
                                    </span>
                                </div>
                                <div class="col-lg-12 mt-3 bg-secondary border rounded" v-if="this.selectedTemplate != null && (this.selectedTemplate.dll_template_id !== '' && this.selectedTemplate.dll_template_id !== null && this.selectedTemplate.dll_template_id !== undefined)">
                                    <label class="fs-6 fw-bold form-label mt-3">
                                        {{ $t('upload_file') }}
                                    </label>
                                    <DxFileUploader
                                        accept= "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
                                        multiple="false"
                                        upload-mode="useButtons" 
                                        :allowed-file-extensions="[allowedExtensions]"
                                        :on-before-send="onUploadStarted"
                                        :visible="true"
                                        :upload-headers="getUploadHeaders()"
                                        upload-url="/api/DataImport/UploadDataTransferFile"
                                        :ref="'fileUploader'"
                                        :on-uploaded="onUploadCompleted"
                                        uploadButtonText="Start Bank Data Import"
                                        :on-upload-error="onUploadError"
                                    /> 
                                    <small class="note mb-5">
                                        {{$t('allowed_file_extensions')}}
                                        <span>{{allowedExtensions}}</span>
                                    </small>
                                    <div class="text-center mt-4" v-if="this.isDataTransferring">
                                        <h4> {{ $t('please_wait_while_data') }}... </h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    
    <!-- Search Account Modal -->
    <div class="modal fade" id="kt_search_account_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <SearchAccountWithSelect ref="SearchAccountWithSelect" :account-type="12"/>
    </div>
    
    <!-- Account Transfer Parameter Modal -->
    <div class="modal fade" id="kt_transfer_parameter_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content"  >
                <div class="modal-header bg-primary">
                    <h2 class="modal-title fw-bolder col-md-10 text-white">{{ $t('add_new_parameter') }}</h2>
                    <div class="btn btn-icon btn-sm btn-active-icon-primary"
                        data-bs-dismiss="modal" aria-label="Close" ref="closeTransferParameterModal">
                        <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body">
                    <div class="col-lg-12">
                        <div class="card card-xxl-stretch mb-3">
                            <div class="card-header min-h-50px">
                                <div class="card-title">
                                    <h3 class="text-gray-800 me-5">
                                        {{ $t('select_account') }}
                                    </h3>
                                </div>
                            </div>
                            <div class="card-body pt-3 pb-3">
                                <div class="row">
                                    <label class="col-lg-4 col-form-label">
                                        {{ $t('account_type') }}
                                    </label>
                                    <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                        <Select2 v-model="modalForm.account_type" :options="accountTypeList" :settings="{ width: '100%', dropdownParent: '#kt_transfer_parameter_modal .modal-content'}"/>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <label class="col-lg-4 col-form-label">
                                        {{ $t('search_account') }}
                                    </label>
                                    <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                        <div class="input-group">
                                            <input type="search" class="form-control form-control-lg" v-model="modalForm.account_name" @keyup.enter="getAccounts()" :placeholder="$t('please_type_an_account')" @input="modalForm.account_id = '-1'" >
                                            <button type="button" class="btn btn-sm btn-light-primary border border-gray-300 z-index-0" @click="getAccounts()">
                                                <span v-if="!isSearchingAccount"><i class="fas fa-search fs-4 me-3"></i> {{ $t('search') }}</span>
                                                <span v-if="isSearchingAccount">{{ $t('Searching...') }}</span> 
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <label class="col-lg-4 col-form-label required">
                                        {{ $t('account') }}
                                    </label>
                                    <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                        <Select2 id="account_id" v-model="modalForm.account_id" :options="accountList" :settings="{ width: '100%', dropdownParent: '#kt_transfer_parameter_modal .modal-content' }" name="account_id"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-lg-12">
                        <div class="card card-xxl-stretch mb-3">
                            <div class="card-body pt-3 pb-3">
                                <div class="row mt-2">
                                    <label class="col-lg-4 col-form-label required">
                                        {{ $t('transaction_type') }}
                                    </label>
                                    <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input type="text" class="form-control" name="transaction_type" v-model="modalForm.transaction_type" disabled>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <label class="col-lg-4 col-form-label required">
                                        {{ $t('inout') }}
                                    </label>
                                    <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                        <input type="text" class="form-control" name="transaction_in_out" v-model="modalForm.transaction_in_out" disabled>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <label class="col-lg-4 col-form-label">
                                        {{ $t('description_parameter') }}
                                    </label>
                                    <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                        <Select2 v-model="modalForm.description_parameter" :options="descriptionParameterList" :settings="{ width: '100%', dropdownParent: '#kt_transfer_parameter_modal .modal-content'}"/>
                                    </div>
                                </div>
                                <div class="row mt-2">
                                    <label class="col-lg-4 col-form-label required">
                                        {{ $t('description') }}
                                    </label>
                                    <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                        <textarea rows="3" class="form-control" name="transaction_description" v-model="modalForm.transaction_description"></textarea>                                        
                                        <div class="input-group" v-if="modalForm.transaction_description_temp !== null && modalForm.transaction_description_temp !== '' && modalForm.transaction_description_temp !== undefined">    
                                            <small class="text-muted p-1 pe-3 bg-light fs-7" ref="textToCopy">{{modalForm.transaction_description_temp}}</small>
                                            <button type="button" class="btn btn-sm btn-icon btn-light w-25px h-25px" 
                                                @click="modalForm.transaction_description = modalForm.transaction_description_temp">
                                                <i class="bi bi-box-arrow-up-right fs-8"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-12">
                        <div class="alert bg-light-primary border border-primary d-flex flex-column flex-sm-row w-100 m-0">
                            <span class="svg-icon svg-icon-primary svg-icon-1 me-1">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
                                    <rect x="11" y="14" width="7" height="2" rx="1" transform="rotate(-90 11 14)" fill="currentColor"/>
                                    <rect x="11" y="17" width="2" height="2" rx="1" transform="rotate(-90 11 17)" fill="currentColor"/>
                                </svg>
                            </span>
                            <div class="d-flex flex-column pe-0 pe-sm-10">
                                <span>{{ $t('the_parameters_you_set') }}.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer row mx-0">
                    <div class="d-grid gap-2">
                        <div class="btn-group"> 
                            <div class="col-lg-12">
                                <div class="d-grid gap-2">
                                    <button v-if="this.modalForm.id == null || this.modalForm.id == '' || this.modalForm.id == undefined" 
                                        type="button" class="btn btn-success btn-lg" @click="saveParameter()">
                                        <span class="indicator-label">{{ $t('save') }}</span> 
                                    </button>
                                    <button v-if="this.modalForm.id !== null && this.modalForm.id !== '' && this.modalForm.id !== undefined" 
                                        type="button" class="btn btn-primary btn-lg" @click="updateParameter()">
                                        <span class="indicator-label">{{ $t('update') }}</span> 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Update Modal -->
    <div class="modal fade" id="kt_update_data_modal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" role="dialog" aria-modal="true">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content"  >
                <div class="modal-header bg-primary">
                    <h2 class="modal-title fw-bolder col-md-10 text-white">{{ $t('update_data') }}</h2>
                    <div class="btn btn-icon btn-sm btn-active-icon-primary"
                        data-bs-dismiss="modal" aria-label="Close" ref="closeUpdateModal">
                        <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body">                    
                    <div class="col-lg-12">
                        <div class="card card-xxl-stretch mb-3">
                            <div class="card-body pt-3 pb-3">
                                <div class="row mt-2">
                                    <label class="col-lg-4 col-form-label ">
                                        {{ $t('inout') }}
                                    </label>
                                    <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                        <Select2 v-model="updateForm.transaction_in_out" :options="inOutTypeList" :settings="{ width: '100%', dropdownParent: '#kt_update_data_modal .modal-content' }" name="transaction_in_out"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer row mx-0">
                    <div class="d-grid gap-2">
                        <div class="btn-group"> 
                            <div class="col-lg-12">
                                <div class="d-grid gap-2">
                                    <button type="button" class="btn btn-success btn-lg" @click="onUpdateSelectedTransactions()">
                                        <span class="indicator-label">{{ $t('save') }}</span> 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>
<style>
.preloader {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1050;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
<script>
import axios from "axios"; 
import moment from 'moment';
import $ from 'jquery';
import { DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSelection,  DxScrolling, DxSummary, DxTotalItem } from 'devextreme-vue/data-grid';
import { DxFileUploader } from 'devextreme-vue/file-uploader';
import { DxPopover } from 'devextreme-vue/popover';
import { DxSelectBox } from 'devextreme-vue/select-box';
import DataGrid from "devextreme/ui/data_grid";
import SearchAccountWithSelect from '../Accounts/Modals/SearchAccountWithSelect.vue';

DataGrid.defaultOptions({ 
    options: {
        scrolling: {
            legacyMode: true
        }
    }
});

export default {
  name: "BankDataImport",  
  components:{
    DxDataGrid, DxFilterRow, DxHeaderFilter, DxGroupPanel, DxExport, DxPaging, DxPager, DxColumn, DxSearchPanel, DxSelection, DxFileUploader, DxPopover, DxSelectBox, DxScrolling, SearchAccountWithSelect, DxSummary, DxTotalItem
  },
  data() {
    return {
        pageSize: 20,
        modalType: 'addItem',  
        bankAccountList: [{id: '-1', text: this.$t('select_an_option')}],
        templateGroupList: [{id: '-1', text: this.$t('select_an_option')}],
        tempDataList: [],
        selectedTemplate: {
            dll_template_id: null,
            dll_template_name: null,
        },
        form: {
            bank_account_id: '-1'
        },
        filterForm: {
            bank_account_id: '-1',
            record_status: 0
        },
        updateForm: {
            transaction_in_out: 0
        },
        filterStatusList:[
            { id: 0, text: this.$t('all')},
            { id: 1, text: this.$t('ready')},
            { id: 2, text: this.$t('not_ready')},
            { id: 3, text: this.$t('saved')}
        ],
        inOutTypeList:[
            { id: 0, text: this.$t('select_an_option')},
            { id: 1, text: this.$t('incoming')},
            { id: 2, text: this.$t('outgoing')},
        ],
        selectedRowKeys: [],
        selectedRowDeleteKeys: [],
        isImporting: false,
        isTempLoading: false,
        deleteMode: false,
        allMode: this.$t('all_pages'),
        selectAllModes: [this.$t('all_pages'), this.$t('page')],
        selectedTempId: null,
        modalForm: {
            id: null,
            account_id: '-1',
            account_type: -4,
            account_name: null,
            transaction_type: null,
            transaction_in_out: null,
            transaction_description: null,
            description_parameter: 1,
            bank_account_id: null,
            transaction_description_temp: null
        },
        accountList: [{id: '-1', text: this.$t('select_an_option')}],
        isSearchingAccount: false,
        accountTypeList: [
            { id: -4, text: this.$t('all')}, /* Except Stock and Asset Accounts */
            { id: 1, text: this.$t('customer')},
            { id: 2, text: this.$t('supplier')},
            { id: 4, text: this.$t('bank')},
            { id: 3, text: this.$t('cash')},
            { id: 6, text: this.$t('expense')},
            { id: 5, text: this.$t('personnel')},
            { id: 15, text: this.$t('other')},
        ],
        descriptionParameterList: [
            { id: 0, text: this.$t('equal_to')},
            { id: 1, text: this.$t('starts_with')},
            { id: 2, text: this.$t('ends_with')},
            { id: 3, text: this.$t('contains')}
        ]
    };
  },
  computed: { 
    dataGrid: function() {
      return this.$refs["dxTempList"].instance;
    },
    previewDate(){
      return (value)=>{
       if (value) {
          return moment(new Date(value)).format('DD.MM.YYYY')
        }
      }
    },
    isReadyToSave(){
        return (data)=>{
            if(data){
                var isReady = true;
                
                if(data.target_account_id == ''){
                    isReady = false;
                }
                if(data.in_out == 0) {
                    isReady = false;
                }
                return isReady;
            } 
        }
    },
    showPageSizeSelector() {
        return(list, pageSize) => {
            return list.length > pageSize;
        }
    },
    pageSizes() {
        return(list, pageSize) => {
            let arr = [];
            let x = 1;
            let loop = (list.length / pageSize);
            for (let i = 1; i <= loop && i <= 5; i++) {
                arr.push(pageSize * x);
                x++;
            }
            if(loop > 5) arr.push(1000);
            if(loop > 1) arr.push('all');
            return arr;
        }
    },
    allowedExtensions() {
      switch(this.selectedTemplate.dll_file_type_id) {
        case 4:
          return '.xls';
        case 3:
          return '.csv';
        case 1:
          return '.xlsx';
        default:
          return '';
      }
    },
    buttonDisabled() {
        return this.deleteMode
        ? this.selectedRowDeleteKeys.length === 0
        : this.selectedRowKeys.length === 0;
    },
    buttonCount() {
        return this.deleteMode
        ? this.selectedRowDeleteKeys.length
        : this.selectedRowKeys.length;
    },
    getFileName() {
        let fileName = "";
        if(this.filterForm.bank_account_id !== '-1' && this.filterForm.bank_account_id !== null && this.filterForm.bank_account_id !== '' && this.filterForm.bank_account_id !== undefined) {
            fileName = '(' + this.bankAccountList.find(p => { return p.id == this.filterForm.bank_account_id; }).text + ')';
        }
        return 'Bank-transaction-import-list' + fileName
    }
  },
  methods: {
    getData() {
        this.isTempLoading = true;
        const parameters = {
            session_id: this.$getUser().session_id,
            record_status: this.filterForm.record_status,
            bank_account_id: this.filterForm.bank_account_id == '-1' ? null : this.filterForm.bank_account_id
        };  
        const that = this;
        axios.post('/api/DataImport/GetTempData', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.tempDataList = response.data;
                this.selectedRowDeleteKeys = [];
                this.selectedRowKeys = [];
            }
        })
        .catch((error) => {
           console.error(error);
        })
        .finally(() => { 
            that.isTempLoading = false;
        });
    },
    getLists() {
        this.form.bank_account_id = '-1';
        this.selectedTemplate = {
            dll_template_id: null,
            dll_template_name: null,
        };
        if(this.$refs.fileUploader) this.$refs.fileUploader.instance.reset();
        const params = {
            session_id : this.$getUser().session_id,
            icl: 1,
            account_type : 4, // Bank: 4
        };  
        const that = this;
        axios.post('api/CompanyAccounts/GetAccounts', params, {'Content-Type': 'application/json'})
        .then((response) => {
            this.bankAccountList = response.data.account_data;      
            this.bankAccountList.forEach(element => {
                element.name = this.$unlock(element.name);
                element.account_id = this.$unlock(element.account_id);
                element.text = this.$unlock(element.text);
            });
            this.bankAccountList.unshift({id : '-1' , text : this.$t('select_an_option')});  

            this.$Progress.finish(); 
             setTimeout(() => {
                this.isListProgressing = false;
            }, 500);
        })
        .catch((error) => {
            console.error(error);
            that.$Progress.finish();
            setTimeout(() => {
                that.isListProgressing = false;
            }, 500);
        }); 
    },
    onChangeAccount(e){
        this.selectedTemplate = e;
    },
    onStartDataTransfer(){
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_start_data_transfer'),
            confirmButtonColor: "#009ef7",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('start_data_transfer'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                this.$refs.uploadForm.submit();
            }
        });
    },
    getUploadHeaders(){
        if(this.selectedTemplate == null){
            return;
        }
        return { 
            session_id: this.$getUser().session_id,
            dll_template_id: this.selectedTemplate.dll_template_id,
            bank_account_id: this.form.bank_account_id
        };
    },
    onUploadStarted(){ 
        this.isDataTransferring = true;
    },
    onUploadCompleted(){
      this.isDataTransferring = false;
      this.$swal(this.$t('success'), this.$t('data_transferred_successfully'), 'success'); 
      this.$refs.closeImportModal.click();
      this.getData();
    },
    onUploadError() {  
      this.$swal(this.$t('failed'), this.$t('an_error_occured_while_uploading_your_file'), 'error'); 
      this.isDataTransferring = false;
    },
    onDeleteAllTempTransactions(){
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_clear'),
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('delete'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                const parameters = {
                    session_id: this.$getUser().session_id,
                    record_status: this.filterForm.record_status,
                    bank_account_id: this.filterForm.bank_account_id == '-1' ? null : this.filterForm.bank_account_id
                };
                axios.post('/api/DataImport/DeleteTempTransferData', parameters, {'Content-Type': 'application/json'}) 
                .then(() => { 
                    this.getData(); 
                })
                .catch((error) => { 
                    console.error(error);
                }); 
            }
        }); 
    },
    onDeleteSelectedTransactions(){
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want'),
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('delete'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                const parameters = {
                    session_id: this.$getUser().session_id,
                    tempDataIds: this.selectedRowDeleteKeys
                };
                axios.post('/api/DataImport/DeleteTransferDataById', parameters, {'Content-Type': 'application/json'}) 
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                        this.deleteMode = false;
                        this.selectedRowDeleteKeys = [];
                        this.selectedRowKeys = [];
                        this.getData();
                    }                    
                })
                .catch((error) => { 
                    console.error(error);
                }); 
            }
        }); 
    },
    onUpdateSelectedTransactions(){
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_update_selected_transactions'),
            confirmButtonColor: "#50cd89",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('confirm'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                const parameters = {
                    session_id: this.$getUser().session_id,
                    in_out: this.updateForm.transaction_in_out,
                    tempDataIds: this.selectedRowDeleteKeys,
                    id: null
                };
                axios.post('/api/DataImport/UpdateTempRow', parameters, {'Content-Type': 'application/json'}) 
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                        this.$refs.closeUpdateModal.click();
                        this.deleteMode = false;
                        this.selectedRowDeleteKeys = [];
                        this.selectedRowKeys = [];
                        this.getData();
                    }                    
                })
                .catch((error) => { 
                    console.error(error);
                }); 
            }
        }); 
    },
    toggleDeleteMode() {
        this.selectedRowDeleteKeys = [];
        this.selectedRowKeys = [];
    }, 
    getTransactionRowById(tempId){
        const parameters = { 
            id: tempId,
            session_id: this.$getUser().session_id
        };
        axios.post("/api/DataImport/GetTempDataById", parameters, {'Content-Type': 'application/json'}).then((response) => {
            if(response.data.length == 0) return;
            const dataSource = this.dataGrid.getDataSource();
            var store = dataSource.store();
            if(response.data.length > 1) {
                response.data.forEach(element => {
                    store.update(element.id,  element)
                    .fail(function (error) { console.error(error) });                    
                });                
                dataSource.reload();
            } else {
                store.update(tempId,  response.data[0])
                .done(function () {
                    dataSource.reload();
                })
                .fail(function (error) { console.error(error) });
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    getRecordedTransactions(){
        this.isImporting = false;
        this.$refs.closeLoadingModal?.click();
        const parameters = { 
            tempIds: this.selectedRowKeys,
            session_id: this.$getUser().session_id
        };
        axios.post("/api/DataImport/GetRecordedTransactions", parameters, {'Content-Type': 'application/json'}).then((response) => {
            if(response.data.length == 0) return;
            const dataSource = this.dataGrid.getDataSource();
            var store = dataSource.store();
            response.data.forEach(element => {
                store.update(element.id,  element)
                .fail(function (error) { console.error(error) });
            });
            dataSource.reload();
            this.clearSelection();
        })
        .catch((error) => {
            console.error(error);
        });
    },
    onSelectAddressSearchResult(item, formName){
        if(item.id == '-1') return;
        this.isViewAddressModal = false;
        this[formName].address = item.ADDRESS;
        this[formName].city = item.POST_TOWN;
        this[formName].district = item.LOCAL_CUSTODIAN_CODE_DESCRIPTION;
        this[formName].customer_x_coordinate = item.X_COORDINATE;
        this[formName].postcode = item.POSTCODE;
        this[formName].apartment_no = item.SUB_BUILDING_NAME;
        this[formName].street_no = item.THOROUGHFARE_NAME;
        this[formName].customer_uprn = item.UPRN;
        this[formName].customer_udprn = item.UDPRN;
        let buildingName = (item.BUILDING_NAME !== null && item.BUILDING_NAME !== undefined && item.BUILDING_NAME !== '') ? item.BUILDING_NAME : '';
        if(item.BUILDING_NUMBER !== null && item.BUILDING_NUMBER !== undefined && item.BUILDING_NUMBER !== '') {
            buildingName = item.BUILDING_NUMBER;
        }
        this[formName].building_no = buildingName;
    }, 
    onSelectItem(array, item) {
        array.forEach((value) => { 
            if (item.id !== value.id) {
                value.isSelected = false;
            }
        });
    },
    onCancelDataImport() {
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_cancel_this_operation'),
            confirmButtonColor: "#f1416c",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('confirm'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                axios.post('/api/DataImport/CancelDataImport', {}, {'Content-Type': 'application/json'})
                .then(() => {})
                .catch((error) => {
                    console.error(error);
                });
            }
        });
    },
    onSaveReadyTransactions(tempId) {
        this.$swal.fire({
            title: this.$t('are_you_sure_you_want_to_save_selected_transactions'),
            confirmButtonColor: "#50cd89",
            showDenyButton: false,
            showCancelButton: true,
        cancelButtonText: this.$t('cancel'),
            confirmButtonText: this.$t('save'),
            icon: 'info'
        })
        .then((result) => {
            if (result.isConfirmed) {
                if(tempId !== null && tempId !== undefined && tempId !== '') this.selectedRowKeys.push(tempId);
                this.isImporting = true;
                this.$refs.LoadingModal.click();
                const parameters = {
                    session_id: this.$getUser().session_id,
                    tempIds: this.selectedRowKeys
                };
                const that = this;
                axios.post('/api/DataImport/SaveReadyTransactions', parameters, {'Content-Type': 'application/json'})
                .then((response) => {
                    if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                        this.$swal(this.$t('success'), this.$t('data_transferred_successfully'), 'success'); 
                        setTimeout(() => {
                            that.isImporting = false;
                            that.$refs.closeLoadingModal.click();
                        }, 500);
                    }
                    this.getRecordedTransactions();
                })
                .catch((error) => {
                    console.error(error);
                    setTimeout(() => {
                        that.isImporting = false;
                        that.$refs.closeLoadingModal.click();
                    }, 500);
                })
                .finally(function() {
                    setTimeout(() => {
                        that.isImporting = false;
                        that.$refs.closeLoadingModal.click();
                    }, 500);
                });
            }
        });
    },
    onSelectionChanged(e) {
        if(!this.deleteMode) {
            this.selectedRowKeys = e.selectedRowsData.filter(x=> x.is_recorded == 0 && x.in_out !== 0 && (x.target_account_id !== '')).map(x => x.id);

            var disabledKeys = e.selectedRowsData.filter(i => i.is_recorded == 1 || i.in_out == 0 || (i.target_account_id == '')).map(i => i.id);
            if (disabledKeys.length > 0)  
            e.component.deselectRows(disabledKeys);
        }else {
            this.selectedRowDeleteKeys = e.selectedRowsData.map(x => x.id);
        }
    },
    onCellPrepared(e) {
        if (e.rowType === "data" && e.column.command === 'select' && (e.data.is_recorded == 1)) {  
            var instance = e.cellElement.find('.dx-select-checkbox').dxCheckBox("instance");  
            instance.option("disabled", true);  
            e.cellElement.off();  
        }  
    },
    clearSelection () {
        this.dataGrid.clearSelection();
    },
    setCriteriasToDefault() {   
        this.filterForm = {
            bank_account_id: '-1',
            record_status: 0
        };
        this.tempDataList = [];
    },
    openSearchModal(searchText, tempID) {
        this.selectedTempId = tempID;
        this.$refs.SearchAccountWithSelect.getData(-4, 0, 0, searchText, false); /* account_type, process_type, invoice_type, search_text, is_create_account */
    },
    getAccountDetail(id) {
        if (id == '-1' || id == null || id == undefined) return;
        const parameters = {
            session_id: this.$getUser().session_id,
            id: this.selectedTempId,
            target_account_id: id,
            in_out: 0,
            tempDataIds: [this.selectedTempId]
        };  
        axios.post('/api/DataImport/UpdateTempRow', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.getTransactionRowById(this.selectedTempId);
                this.selectedTempId = null;
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    saveParameter() {
        if (this.modalForm.account_id == '-1' || this.modalForm.account_id == null || this.modalForm.account_id == undefined) return;
        const params = {
            session_id: this.$getUser().session_id,
            parent_account_id: this.modalForm.account_id,
            transaction_type: this.modalForm.transaction_type,
            transaction_in_out: this.modalForm.transaction_in_out,
            transaction_description: this.modalForm.transaction_description,
            description_parameter: this.modalForm.description_parameter,
            bank_account_id: this.modalForm.bank_account_id
        };
        axios.post('api/CompanyAccounts/CreateTransferParameter',params,{'Content-Type' : 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.$refs.closeTransferParameterModal.click();
                this.getAccountDetail(this.modalForm.account_id);
                this.clearTransferParameterForm();
            }
        })
        .catch((error) => {
            console.error(error);
        });
    },
    updateParameter() {
        if (this.modalForm.account_id == '-1' || this.modalForm.account_id == null || this.modalForm.account_id == undefined) return;
        const params = {
            session_id : this.$getUser().session_id,
            id: this.modalForm.id,
            transaction_type: this.modalForm.transaction_type,
            transaction_in_out: this.modalForm.transaction_in_out,
            transaction_description: this.modalForm.transaction_description,
            description_parameter: this.modalForm.description_parameter,
            bank_account_id: this.modalForm.bank_account_id == '-1' ? null : this.modalForm.bank_account_id
        };
        axios.post('api/CompanyAccounts/UpdateTransferParameter',params,{'Content-Type' : 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                this.$swal(this.$t('success'), this.$t('data_update_succesfully'), 'success');
                this.$refs.closeTransferParameterModal.click();
                this.getAccountDetail(this.modalForm.account_id);
                this.clearTransferParameterForm();
            }
        })
        .catch((error) => {
            console.error(error);
        });
        
    },
    getAccounts(isNotExpandOptionBox) {
        if((this.modalForm.account_name == '' || this.modalForm.account_name == null || this.modalForm.account_name == undefined || this.modalForm.account_name.length < 1) && !this.$getUser().is_allow_list_all_data) return;
        this.isSearchingAccount = true;
        const accountParams = {
            session_id : this.$getUser().session_id,
            account_type : this.modalForm.account_type,
            search_text: this.modalForm.account_name == null ? "" : this.modalForm.account_name,
            search_parameter: 1  // 1: Search By Account Name
        };  
        const that = this;
        axios.post('api/CompanyAccounts/GetAccounts', accountParams, {'Content-Type': 'application/json'}).then((response) => { 
            this.accountList = response.data.account_data;
            this.accountList.forEach(element => {
                element.name = this.$unlock(element.name);
                element.account_id = this.$unlock(element.account_id);
                element.text = this.$unlock(element.text);
            });
            this.accountList.forEach((item) => {
                item.text = item.text + ' (' + item.account_type_name + ')';
            });
            this.accountList.unshift({id : '-1' , text : this.$t('select_an_option')});

            if(!isNotExpandOptionBox) {
                var $optionBox = $("#account_id").select2();
                setTimeout(() => {$optionBox.select2("open");}, 100);
            }
        })
        .catch(function(error) {
            console.error(error);
        })
        .finally(() => { 
            that.isSearchingAccount = false;
        });
    },
    clearTransferParameterForm() {
        this.modalForm = {
            id: null,
            account_id: '-1',
            account_name: null,
            account_type: -4,
            transaction_type: null,
            transaction_in_out: null,
            transaction_description: null,
            description_parameter: 1,
            bank_account_id: null,
            transaction_description_temp: null
        };
    },
    openTransferParameterForm(data) {
        const selectedTempData = data;
        this.selectedTempId = data.id;
        this.modalForm = {
            id: null,
            account_type: -4,
            account_id: (selectedTempData.target_account_id !== null && selectedTempData.target_account_id !== '' && selectedTempData.target_account_id !== undefined) ? selectedTempData.target_account_id : '-1',
            account_name: selectedTempData.target_account_name,
            transaction_type: selectedTempData.transaction_type,
            transaction_in_out: selectedTempData.transaction_in_out,
            transaction_description: null,
            transaction_description_temp: selectedTempData.transaction_description,
            description_parameter: 1,
            bank_account_id: selectedTempData.local_bank_account_id
        };

        const parameters = {
          session_id: this.$getUser().session_id,
          temp_id: selectedTempData.id
        };  
        axios.post('/api/CompanyAccounts/GetTransferParametersById', parameters, {'Content-Type': 'application/json'})
        .then((response) => {
            if(response.data.error == null || response.data.error == 'undefined' || response.data.error == ''){
                if(response.data.id !== null && response.data.id !== 'undefined' && response.data.id !== ''){
                    this.modalForm = {
                        id: response.data.id,
                        account_type: -4,
                        account_id: selectedTempData.target_account_id ?? '' ? selectedTempData.target_account_id : (response.data.parent_account_id || '-1'),
                        account_name: selectedTempData.target_account_name,
                        transaction_type: response.data.transaction_type,
                        transaction_in_out: response.data.transaction_in_out,
                        transaction_description: response.data.transaction_description,
                        description_parameter: response.data.description_parameter,
                        bank_account_id: selectedTempData.local_bank_account_id,
                        transaction_description_temp: null
                    };
                }
            }
            if(this.modalForm.account_id !== null && this.modalForm.account_id !== '' && this.modalForm.account_id !== undefined) this.getAccounts(true);
        })
        .catch((error) => {
           console.error(error);
        });
    }
  },
  created() {
    this.getLists();
  },
  
}; 
</script>